export default __webpack_public_path__ + "static/media/video-control-left.7c16066e.svg";